// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__31Ps2","bigColWidth":"Table_bigColWidth__a12In","biggerColWidth":"Table_biggerColWidth__3s0YM","row":"Table_row__2uTGJ","col":"Table_col__3RQ3Y"};